import React, { useEffect, useState } from "react";
import { getMembershipGuest } from "../apis/paymentsApi";
import { useAuth } from "../Context/AuthContext";
import { useNotification } from "../Context/NotificationContext";
import MembershipFeePayment from "./MembershipFeePayment";

// A guest: registered, membership fee not paid (chose "Continue as Guest", or the payment didn't go through). The
// account has guest access only (fpo RegistrationActivator; feed's access check treats it as a Guest) until the fee
// is paid. Shown at the top of every page (AppShell) with "Become a member", which opens the same payment window
// as at registration. Once paid, fpo activates the membership (Company registrations within a minute) and the
// user's access is reloaded.

export default function GuestMembershipBanner() {
  const { reloadUserData } = useAuth();
  const { showSuccess } = useNotification();
  const [guest, setGuest] = useState(false);
  const [paying, setPaying] = useState(false);
  const [activating, setActivating] = useState(false);

  const load = () => getMembershipGuest().then((res) => setGuest(!!res.data?.data?.guest)).catch(() => setGuest(false));
  useEffect(() => { load(); }, []);

  const finished = async (outcome) => {
    setPaying(false);
    if (outcome === "paid" || outcome === "none") {
      setActivating(true);
      showSuccess("Thank you! Your membership is being activated.");
      // fpo activates it once the payment is recorded (a Company registration: within a minute)
      setTimeout(async () => {
        try { await reloadUserData(); } catch { /* silent */ }
        load();
        setActivating(false);
      }, 4000);
    } else if (outcome === "confirming") {
      showSuccess("We're confirming your payment with the bank. Your membership starts as soon as it's confirmed.");
    }
  };

  if (!guest) return null;
  return (
    <>
      <div role="status"
        style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 12, margin: "0 0 16px", padding: "14px 18px",
          borderRadius: 14, background: "linear-gradient(135deg, #1f5f7a, #2e8a9a)", color: "#fff",
          boxShadow: "0 8px 22px rgba(31, 95, 122, 0.25)" }}>
        <div style={{ width: 40, height: 40, borderRadius: 10, background: "rgba(255,255,255,0.18)", display: "grid", placeItems: "center", flex: "none" }}>
          <i className="fas fa-user" aria-hidden="true" />
        </div>
        <div style={{ flex: "1 1 260px", minWidth: 0 }}>
          <div style={{ fontWeight: 700, fontSize: 15 }}>
            {activating ? "Your membership is being activated" : "You're using FEED as a guest"}
          </div>
          <div style={{ fontSize: 13, opacity: 0.92 }}>
            {activating
              ? "This takes up to a minute. If a page still shows guest access afterwards, sign out and sign in again."
              : "Guests can look around the public services. Pay the one-time membership fee to unlock the member services, plans and subscriptions."}
          </div>
        </div>
        {!activating && (
          <button type="button" onClick={() => setPaying(true)}
            style={{ border: 0, borderRadius: 10, padding: "10px 18px", background: "#fff", color: "#1f5f7a", fontWeight: 700, fontSize: 14,
              cursor: "pointer", whiteSpace: "nowrap" }}>
            <i className="fas fa-id-card me-2" aria-hidden="true" />Become a member
          </button>
        )}
      </div>
      {paying && <MembershipFeePayment signedIn onFinished={finished} />}
    </>
  );
}
